import { useState } from "react";

import type { FeatureIntroSlideId } from "../types";

interface FeatureIntroductionSlideProps {
  readonly slideId: FeatureIntroSlideId;
  readonly number: "01" | "02" | "03" | "04";
  readonly title: string;
  readonly imageSource: string;
  readonly imageWidth: number;
  readonly imageHeight: number;
  readonly imageAlt: string;
}

export function FeatureIntroductionSlide({
  slideId,
  number,
  title,
  imageSource,
  imageWidth,
  imageHeight,
  imageAlt,
}: FeatureIntroductionSlideProps) {
  const [imageAvailable, setImageAvailable] = useState(true);
  const titleId = `${slideId}-slide-title`;

  return (
    <article
      className={`content-slide feature-intro-slide ${slideId}-slide`}
      aria-labelledby={titleId}
      data-feature-id={slideId}
    >
      <div className={`feature-intro-heading ${slideId}-heading`}>
        <p className="slide-kicker"><span>{number}</span> FEATURE INTRODUCTION</p>
        <h2 id={titleId}>{title}</h2>
      </div>
      <div
        className={`feature-intro-visual ${slideId}-visual`}
        data-image-available={imageAvailable ? "true" : "false"}
      >
        {imageAvailable ? (
          <img
            className={`feature-intro-image ${slideId}-image`}
            src={imageSource}
            alt={imageAlt}
            width={imageWidth}
            height={imageHeight}
            decoding="sync"
            loading="eager"
            fetchPriority="high"
            onError={() => setImageAvailable(false)}
          />
        ) : null}
        <div
          className={`feature-intro-image-shade ${slideId}-image-shade`}
          aria-hidden="true"
        />
      </div>
    </article>
  );
}
